import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import queryString from 'query-string'
import Pagination from '../../../components/pagination'
import { loadPools, loadPoolsAsync, search, addOnClick, bulkScheduleUpload } from '../../../actions/poolIndex'
import { downloadSchedulesAsync } from '../../../actions/schedules'
import { addInfoNotification, addErrorNotification } from '../../../actions/notifications'
import Order from './order'
import Wrapper from '../../../components/wrapper'
import Loader from '../../../components/loader'
import PoolRow from './poolRow'
import ThrottleInput from '../../../components/throttleInput'
import qs from 'query-string'
import Error from '../../../components/alerts/error'
import IsOffline from './isOffline'
import PropTypes from 'prop-types'
import DropDown from '../../../components/scheduleUpload/dropdown'
import ScheduleDownloadButton from '../../../components/scheduleDownload'
import { canManageLegacyTakeawayPoolActions, isMagicEnabledFromSearch } from '../../../helpers/tenant'
import { HIDE_POOL_SHIFTS } from '../../../constants/featureFlags'
import { normalizePoolStatus } from '../../../constants/poolStatuses'

export class Pools extends React.Component {
  componentDidMount() {
    this.loadPools()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.searchCriteria.page !== this.props.searchCriteria.page ||
      prevProps.searchCriteria.sortField !== this.props.searchCriteria.sortField ||
      prevProps.searchCriteria.sortDirection !== this.props.searchCriteria.sortDirection ||
      prevProps.searchCriteria.pool !== this.props.searchCriteria.pool ||
      prevProps.searchCriteria.restaurant !== this.props.searchCriteria.restaurant ||
      prevProps.searchCriteria.partner !== this.props.searchCriteria.partner ||
      prevProps.searchCriteria.status !== this.props.searchCriteria.status ||
      prevProps.tenant !== this.props.tenant) {
      this.loadPools()
    }
  }

  loadPools() {
    this.props.loadPoolsAsync({
      ...this.props.searchCriteria,
      itemsPerPage: this.props.itemsPerPage
    })
  }

  filter(newCriteria) {
    const query = { ...this.props.searchCriteria, ...newCriteria, page: 1 }
    const searchString = qs.stringify(query)

    this.props.search(searchString)
  }

  render() {
    const canManagePoolActions = canManageLegacyTakeawayPoolActions(this.props.tenant, this.props.isMagicEnabled)
    const poolActionsTooltip = canManagePoolActions ? '' : 'Function disabled for legacy Takeaway countries.'
    const poolActionsClassName = canManagePoolActions ? '' : 'legacy-disabled-action'

    let body
    if (this.props.error !== undefined) {
      body = <tr><td colSpan={HIDE_POOL_SHIFTS ? 5 : 6}><Error title="Error loading pools" body={this.props.error} /></td></tr>
    }
    else if (this.props.isLoading) {
      body = <tr><td colSpan={HIDE_POOL_SHIFTS ? 5 : 6}><Loader /></td></tr>
    }
    else if (this.props.pools !== null && this.props.pools.length > 0) {
      body = this.props.pools.map(p => (<PoolRow tenant={this.props.tenant} locationSearch={this.props.locationSearch} pool={p} key={p.id} />))
    }


    const toolbar = (
      <div className="btn-group btn-toolbar mr-2">

        <div className="mr-1">
          <span className="btn btn-secondary btn-sm btn-file">
            <span className="fa fa-plus" /><span> Add pool</span>
            <input type="button" onClick={() => this.props.addOnClick(this.props.locationSearch)}/>
          </span>
        </div>
        <div className="mr-1">
          <DropDown
            disabled={!canManagePoolActions}
            disabledTitle={poolActionsTooltip}
            buttonClassName={poolActionsClassName}
            onBulkScheduleUpload={() => this.props.bulkScheduleUpload(this.props.locationSearch)}
            onScheduleFileUploadSuccess={this.props.addInfoNotification}
            onScheduleFileUploadonError={this.props.addErrorNotification}
          />
        </div>
        <div>
          <ScheduleDownloadButton
            onClick={() => this.props.downloadSchedulesAsync(this.props.tenant)}
            isDownloading={this.props.isDownloadingSchedule}
          />
        </div>
      </div>
    )

    return <Wrapper title="Pools" toolbar={toolbar}>
      <table className="table table-hover table-striped table-condensed">
        <thead>
          <tr>
            <th style={{ width: '15%' }}>
              Pool
              <Order type="alpha" sortField="name" pool={this.props.searchCriteria.pool} restaurant={this.props.searchCriteria.restaurant} sortDirection={this.props.searchCriteria.sortField === 'name' ? this.props.searchCriteria.sortDirection : null} />
            </th>
            <th style={{ width: '10%' }}>Partner</th>
            <th style={{ width: '40%' }}>Restaurants</th>
            {!HIDE_POOL_SHIFTS && <th style={{ width: '10%' }}>Active Drivers</th>}
            <th style={{ width: '15%' }}>Next available pickup <Order type="amount" sortField="NextAvailablePickupTimeUtc" restaurant={this.props.searchCriteria.restaurant} pool={this.props.searchCriteria.pool} sortDirection={this.props.searchCriteria.sortField === 'NextAvailablePickupTimeUtc' ? this.props.searchCriteria.sortDirection : null} /></th>
            <th style={{ width: '10%' }}>Status</th>
          </tr>
          <tr>
            <th><ThrottleInput placeholder="Pool" value={this.props.searchCriteria.pool} onCallback={(val) => this.filter({ pool: val.trim() })} /></th>
            <th><ThrottleInput placeholder="Partner" value={this.props.searchCriteria.partner} onCallback={(val) => this.filter({ partner: val.trim() })} /></th>
            <th><ThrottleInput placeholder="Restaurant" value={this.props.searchCriteria.restaurant} onCallback={(val) => this.filter({ restaurant: val.trim() })} /></th>
            {!HIDE_POOL_SHIFTS && <th />}
            <th />
            <th><IsOffline value={this.props.searchCriteria.status} onChange={(val) => this.filter({ status: val })} /></th>
          </tr>
        </thead>
        <tbody>
          {body}
        </tbody>
      </table><Pagination url={'/pools'} params={{ pool: this.props.searchCriteria.pool, status: this.props.searchCriteria.status, restaurant: this.props.searchCriteria.restaurant, sortField: this.props.searchCriteria.sortField, sortDirection: this.props.searchCriteria.sortDirection }} page={this.props.searchCriteria.page} itemsPerPage={this.props.itemsPerPage} totalItems={this.props.totalItems} />
    </Wrapper>
  }
}

Pools.propTypes = {
  error: PropTypes.string,
  isLoading: PropTypes.bool,
  pools: PropTypes.array,
  search: PropTypes.func,
  searchCriteria: PropTypes.object,
  tenant: PropTypes.string,
  isMagicEnabled: PropTypes.bool,
  locationSearch: PropTypes.string,
  itemsPerPage: PropTypes.number,
  loadPoolsAsync: PropTypes.func,
  addInfoNotification: PropTypes.func,
  addErrorNotification: PropTypes.func,
  downloadSchedulesAsync: PropTypes.func,
  totalItems: PropTypes.number,
  addOnClick: PropTypes.func.isRequired,
  bulkScheduleUpload: PropTypes.func.isRequired,
  isDownloadingSchedule: PropTypes.bool
}

const mapStateToProps = state => {
  let queryStringParsed = queryString.parse(state.router.location.search)
  let page = parseInt(queryStringParsed.page, 10) || 1
  let sortField = queryStringParsed.sortField || 'name'
  let pool = queryStringParsed.pool || ''
  let partner = queryStringParsed.partner || ''
  let restaurant = queryStringParsed.restaurant || ''
  let status = normalizePoolStatus(queryStringParsed.status, queryStringParsed.isOffline)
  let sortDirection = queryStringParsed.sortDirection || 'asc'
  let locationSearch = state.router.location.search || ''
  return {
    searchCriteria: {
      page: page,
      pool: pool,
      restaurant: restaurant,
      partner: partner,
      status: status,
      sortField: sortField,
      sortDirection: sortDirection,
    },
    pools: state.poolIndex.pools,
    isLoading: state.poolIndex.isLoading,
    totalItems: state.poolIndex.totalItems,
    itemsPerPage: state.poolIndex.itemsPerPage,
    error: state.poolIndex.error,
    user: state.oidc.user,
    tenant: state.system.tenant,
    isDownloadingSchedule: state.schedules.isDownloading,
    isMagicEnabled: isMagicEnabledFromSearch(locationSearch),
    locationSearch: locationSearch
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  search,
  loadPools,
  loadPoolsAsync,
  addInfoNotification,
  addErrorNotification,
  downloadSchedulesAsync,
  addOnClick,
  bulkScheduleUpload
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Pools)



// WEBPACK FOOTER //
// ./src/containers/pools/index/index.js